import Box from '@mui/material/Box';
import SunOutlined from '@ant-design/icons/SunOutlined';

const MoonIcon = ({ color }) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill={color}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export default function DarkModeToggle({ mode, onToggle }) {
  const isDark = mode === 'dark';

  return (
    <Box
      onClick={onToggle}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: 72,
        height: 38,
        borderRadius: 50,
        bgcolor: isDark ? '#1e2125' : '#e8eaed',
        p: '4px',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background-color 0.3s',
        flexShrink: 0,
      }}
    >
      {/* Thumb deslizante */}
      <Box
        sx={{
          position: 'absolute',
          width: 30,
          height: 30,
          borderRadius: '50%',
          bgcolor: isDark ? '#2e3238' : '#ffffff',
          boxShadow: isDark
            ? '0 2px 6px rgba(0,0,0,0.5)'
            : '0 2px 6px rgba(0,0,0,0.18)',
          left: 4,
          top: 4,
          transform: isDark ? 'translateX(34px)' : 'translateX(0)',
          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s',
          zIndex: 0,
        }}
      />

      {/* Sol */}
      <Box sx={{ width: 32, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
        <SunOutlined style={{ fontSize: 16, color: isDark ? '#555' : '#f59e0b' }} />
      </Box>

      {/* Lua */}
      <Box sx={{ width: 32, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
        <MoonIcon color={isDark ? '#e5e7eb' : '#9ca3af'} />
      </Box>
    </Box>
  );
}
